import React from 'react'
import { observer } from 'mobx-react'
import EmbededEntityInput from '../../input/embedded_entity'
import OptionsField from 'react-mobx-admin/components/common/field/opts'
import RegionsInput from '../../input/regions'
import SelectInput from '../../input/select'
import TextField from 'react-mobx-admin/components/common/field/text'
import TextInput from 'bstrap-react-mobx-admin/input/text'

const RatingsEdit = ({ store, items, updateField, ...rest }) => {
  const _RatingsEditForm = ({ record, updateFormField, errors }) => {
    return (
      <div className='row'>
        <div className='col-xs-12'>
          <SelectInput
            label={store.__('Rating')}
            attr={'rating_system_id'}
            record={record}
            onChange={updateFormField}
            optionsrecord={store.options}
            optionsattr={'rating'}
            labelattr={val => {
              const desc = val.hasOwnProperty('description') && val.description
                ? ` - ${val.description.substring(0, 100) + (val.description.length > 100 ? '...' : '')}`
                : ''
              return `${val.name || ''} ${desc}`
            }}
            valueattr='id'
            errors={errors} />
          <RegionsInput label={store.__('region')} attr={'region'}
            record={record} onChange={updateFormField} errors={errors}
            optionsrecord={store.options} optionsattr={'Countries'} />
          <SelectInput label={store.__('platform')} attr={'platform'} record={record}
            onChange={updateFormField} optionsrecord={store.options}
            optionsattr={'Platforms'} labelattr='text' errors={errors} />
          <TextInput
            label={store.__('reason')}
            attr={'reason'}
            record={record}
            onChange={updateFormField}
            errors={errors} />
        </div>
      </div>
    )
  }

  return (
    <EmbededEntityInput
      store={store}
      helper='films/common/ratings'
      label={store.__('Ratings')}
      attr={'film_rating'}
      edit_title={store.__('edit rating')}
      add_title={store.__('add rating')}
      fields={[
        (attr, row) => {
          const DetailLink = ({ text }) => (
            <a href='javascript:void(0)' onClick={() => {
              store.beforeEditViewExit() && store.router.goTo(store.views.entity_detail, {
                entityname: 'rating', id: row['rating_system_id']
              }, store)
            }}><span className='glyphicon glyphicon-share-alt' />&nbsp;{text}</a>
          )
          return (
            <OptionsField
              attr={attr}
              val={row[attr]}
              options={store.options.get('rating')}
              labelattr='name'
              valueattr='id'
              Component={DetailLink} />
          )
        },
        (attr, row) => (<TextField attr={attr} val={row[attr]} />),
        (attr, row) => (
          <OptionsField attr={attr} val={row[attr]}
            options={store.options.get('Platforms')}
            labelattr='text' valueattr='value' />
        ),
        (attr, row) => (<TextField attr={attr} val={row[attr]} />)
      ]}
      rowId={(row) => (row.id)}
      EditForm={_RatingsEditForm} {...rest}
    />
  )
}

export default observer(RatingsEdit)
